import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as s } from "tslib";
import { LitElement as r, html as i } from "lit";
import { property as o } from "lit/decorators.js";
import n from "./mobile-menu-avatar-styles.js";
var a, l, u;
class c extends r {
  constructor() {
    super(...arguments), a.set(this, ""), l.set(this, ""), u.set(this, "");
  }
  get username() {
    return e(this, a, "f");
  }
  set username(t) {
    s(this, a, t, "f");
  }
  get unit() {
    return e(this, l, "f");
  }
  set unit(t) {
    s(this, l, t, "f");
  }
  get type() {
    return e(this, u, "f");
  }
  set type(t) {
    s(this, u, t, "f");
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.setAttribute("type", this.closest("ids-header").getAttribute("type"));
  }
  renderAvatar() {
    switch (this.type) {
      case "1177-pro":
        return i`<ids-row align="center"><ids-col class="user-icon" cols="auto"><ids-icon-user colorpreset="1" width="1.625rem" height="1.625rem"></ids-icon-user></ids-col><ids-col class="username" align="start">${this.username}</ids-col><ids-col cols="auto" align="end"><slot></slot></ids-col></ids-row>`;
      case "inera-admin":
      case "inera-admin-legacy":
        return i`<ids-row><ids-col cols="12"><p class="user-info">${this.username}<br>${this.unit}</p></ids-col><ids-col><slot></slot></ids-col></ids-row>`;
      default:
        return i``;
    }
  }
  render() {
    return i`${this.renderAvatar()}`;
  }
}
a = new WeakMap(), l = new WeakMap(), u = new WeakMap(), c.styles = [n], t([o({
  type: String
})], c.prototype, "username", null), t([o({
  type: String
})], c.prototype, "unit", null), t([o({
  type: String,
  reflect: !0
})], c.prototype, "type", null);
export { c as IDSMobileMenuAvatar };